export default "__VITE_ASSET__BIhbSNJk__"